import { isFeatureEnabled } from '@/utils/featureFlags';

export default [
  {
    path: '/launch-fee',
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),    
    meta: { featureFlag: 'VUE_APP_FEATURE_LAUNCH_PERMIT' },
    beforeEnter: (to) => {
      // returning false cancels navigation [2](https://router.vuejs.org/guide/advanced/navigation-guards.html)
      if (!isFeatureEnabled(to.meta.featureFlag)) return false;
      return true;
    },
    children: [
      {
        path: "",
        name: 'LaunchPermit',
        component: () => import('@/views/LaunchPermit/LaunchPermitView.vue')
      },
      {
        path: "confirmation/:orderId",
        name: "Launch Fee Confirmation",
        props: true,
        component: () => import("@/views/LaunchPermit/LaunchPermitView.vue"),
        meta: { confirmation: true, failure: false }
      },
      {
        path: "failure/:orderId",
        name: "Launch Fee Failure",
        component: () => import("@/views/LaunchPermit/LaunchPermitView.vue"),
        props: true,
        meta: { confirmation: false, failure: true }
      }
    ]
    
  }
];